import { graphql } from 'relay-runtime';

export const createUsers = graphql`
  mutation UsersCreateUsersMutation($input: CreateUsersInput!) {
    createUsers(input: $input) {
      createUserResult {
        createdUsers {
          id
          firstName
          lastName
          publicUserId
          isActive
          roles {
            name
          }
          sites {
            id
            name
          }
          classes {
            name
          }
          gradeLevels {
            name
            id
          }
          email
        }
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

export const getAllUserRoles = graphql`
  query UsersAllRolesQuery {
    allRoles {
      nodes {
        id
        name
        summary
        isActive
      }
    }
  }
`;

export const getInactiveUserByEmail = graphql`
  query UsersGetUserByEmailQuery($email: String!, $skip: Boolean = false) {
    allUsers(filter: { userEmails: [$email], isActive: INACTIVE }) @skip(if: $skip) {
      nodes {
        id
        isActive
      }
    }
  }
`;

export const getExistingUsersByEmails = graphql`
  query UsersGetUsersByEmailQuery($input: AllUsersFilterInput!, $cursor: String, $skip: Boolean = false) {
    allUsers(first: 100, after: $cursor, filter: $input) @skip(if: $skip) {
      nodes {
        id
        email
        firstName
        lastName
        isActive
        sites {
          id
          name
        }
        gradeLevels {
          id
          name
        }
        userClasses {
          isActive
          class {
            id
            name
            section
          }
        }
        roles {
          id
          name
        }
        externalSync {
          source
        }
      }
      pageInfo {
        endCursor
      }
    }
  }
`;

export const updateUser = graphql`
  mutation UsersUpdateUsersMutation($input: UpdateUserInput!) {
    updateUser(input: $input) {
      operationStatus {
        isSuccessful
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

export const usersByRoleClassesRoster = graphql`
  query UsersByRoleClassesRosterQuery(
    $filter: AllUsersFilterInput!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $order: [UserSortInput!]
    $skip: Boolean = false
  ) {
    allUsers(filter: $filter, first: $first, after: $after, last: $last, before: $before, order: $order)
      @skip(if: $skip) {
      nodes {
        externalSync {
          source
        }
        id
        email
        publicUserId
        firstName
        lastName
        isActive
        roles {
          name
          id
        }
        sites {
          id
          name
        }
        classes {
          name
          section
          id
        }
        userClasses {
          isActive
          class {
            id
            name
            section
          }
        }
        gradeLevels {
          name
          id
        }
        studentTargetGroups {
          id
          isCurrent
          targetGroup {
            id
            name
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;
